/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * ProgressCardStyles
 *
 * @file ProgressCardStyles.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */
import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';


const useProgressCardStyle = makeStyles(() => ({
  progressCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'flex-start',
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '16px'
  },
  progressCardContent: {
    display: 'flex',
    gap: 16
  },
  progressCardHeader: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    height: 24,
    width: '100%'
  },
  progressCardTitle: {
    color: mixins.color_text_primary,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize20,
    lineHeight: '28px',
    fontWeight: mixins.fontWeight500,
    flex: 1,
    letterSpacing: '-0.4'
  },
  progressCardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'flex-start',
    width: '100%'
  },
  progressStatsSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    height: 128,
    width: '100%'
  },
  progressItemsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    alignItems: 'flex-start',
    flex: 1
  },
  progressItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    width: 'fit-content',
    cursor: 'pointer'
  },
  statusDotContainer: {
    width: 8,
    height: 8,
    position: 'relative'
  },
  dotBase: {
    borderRadius: '50%',
    width: 8,
    height: 8,
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    top: 0,
    bottom: 0
  },
  dotBaseHover: {
    outline: '1px solid currentColor',
    outlineOffset: 1
  },
  statusLabel: {
    color: mixins.zambezi,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight500
  },
  percentageText: {
    color: mixins.zambezi,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight600,
    marginLeft: 4
  },
  progressCardFooter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },
  dateSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center'
  },
  dateLabel: {
    color: mixins.zambezi,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight500
  },
  dueDateLabel: {
    color: mixins.greyScaleColor,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight500
  },
  badgeLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  badgeWrapper: {
    padding: '2px 0px'
  }
}));

export default useProgressCardStyle;
